/**
 * Central registry of "New Feature" badges.
 *
 * To mark a feature as new, add an entry here.
 * To retire the badge, remove the entry.
 *
 * Seen state is stored in localStorage so each browser/user tracks independently.
 */

export interface NewFeature {
  /** Unique stable identifier for this feature */
  id: string;
  /** Sidebar nav href that should show a NEW dot (e.g. '/settings') */
  navHref: string;
  /** Settings inner tab key that should show a NEW badge (optional) */
  settingsTab?: string;
  /** Widget section accordion ID that should show a NEW badge (optional, e.g. 'core') */
  widgetSection?: string;
}

export const NEW_FEATURES: NewFeature[] = [
  {
    id: 'widget-brand-field',
    navHref: '/settings',
    settingsTab: 'widget',
    widgetSection: 'core',
  },
  {
    id: 'preview-reload-button',
    navHref: '/keys',
  },
  {
    id: 'engagement-dashboard',
    navHref: '/'
  },
];
